import { iValueWithLabelProps } from "../types";

export const ValueWithLabel = ({ label, children }: iValueWithLabelProps) => (
    <div className="value-with-label">
        <div className="value-with-label__label">{label}</div>
        <div>{children || "--"}</div>
    </div>
);
